import Router from 'vue-router'
import scrollhelper from './scripts/scrollhelper'
const Home = () => import('./hklii/Home')
const About = () =>import('./hklii/About')
const Legal = () =>import('./hklii/Legal')
const NotFound = () => import('./hklii/404')
const Liis = () => import('./hklii/Liis')
const Donors = () => import('./hklii/Donors')
const Sponsor = () => import('./hklii/HKLII2023')
const News = () => import('./hklii/NewsRelease')
const Operators = () => import('./hklii/Operators')
const Feedback = () => import('./hklii/Feedback')
const FeedbackSuccess = () => import('./hklii/FeedbackSuccess')

const Databases = () => import('./hklii/Databases')
const CaseDb  = () => import('./hklii/CaseDb')
const LegisDb = () => import('./hklii/LegisDb')
const HOPTDb = () => import('./hklii/HOPTDb')

const Case = () => import('./hklii/Case')
const Treaty = () => import('./hklii/Treaty')
const Pdf = () => import('./hklii/Pdf')
const PD = () => import('./hklii/PD')
const SectionToc = () => import('./hklii/SectionToc')

const Section = () => import('./hklii/Section')
const Compare = () => import('./hklii/Compare')
const AdvancedSearch = () => import('./hklii/AdvancedSearch')
const SearchResults = () => import('./hklii/SearchResults')
const AppealHistory = () => import('./hklii/AppealHistory')

export const router = new Router({
  mode:'history',
  routes:[
    {path: '/', component:Home, name:'home'},
    {path: '/about', component: About, name:'about'},
    {path: '/legal', component: Legal, name:'legal'},
    {path: '/feedback', component: Feedback, name:'feedback'},
    {path: '/feedback/success', component: FeedbackSuccess, name:'feedback-success'},
    {path: '/liis', component: Liis, name:'liis'},
    {path: '/operators', component: Operators, name:'operators'},
    {path: '/404', component: NotFound, name:'404'},
    {path: '/:lang/legis/:abbr/:cap/:num/compare', component:Compare, name:'compare'},
    {path: '/databases', component: Databases, name:'databases'},
    {path: '/donors', component:Donors, name:'donors'},
    {path: '/hklii2023', component: Sponsor, name:'hklii2023'},
    {path: '/news', component: News, name:'news'},
    {path: '/advancedsearch', component:AdvancedSearch, name:'advanced-search'},
    {path: '/search', component:SearchResults, name:'search-results'},
    {path: '/noteup/cases', component:SearchResults, name:'case-noteup'},
    {path: '/noteup/legis', component:SearchResults, name:'legis-noteup'},
    {path: '/:lang/cases/ukpc/', component:HOPTDb, name:'ukpc-db'},
    {path: '/:lang/cases/:abbr/', component:CaseDb, name:'case-db'},
    {path: '/:lang/cases/ukpc/:year/:num', component:Pdf, name:'ukpc-pdf'},
    {path: '/:lang/cases/:abbr/:year/:num', component:Case, name:'case'},
    {path: '/:lang/legis/histlaw/', component:HOPTDb, name:'histlaw-db'},
    {path: '/:lang/legis/hktmc/', component:HOPTDb, name:'hktmc-db'},
    {path: '/:lang/legis/hktml/', component:HOPTDb, name:'hktml-db'},
    {path: '/:lang/legis/bahkg/', component:HOPTDb, name:'bahkg-db'},
    {path: '/:lang/legis/bacpg/', component:HOPTDb, name:'bacpg-db'},
    {path: '/:lang/legis/hkts/', component:HOPTDb, name:'hkts-db'},
    {path: '/:lang/legis/:abbr/', component:LegisDb, name:'legis-db'},
    {path: '/:lang/legis/histlaw/:year/:num', component:Pdf, name:'histlaw-pdf'},
    {path: '/:lang/legis/hktmc/:year/:num', component:Treaty, name:'hktmc'},
    {path: '/:lang/legis/hktml/:year/:num', component:Treaty, name:'hktml'},
    {path: '/:lang/legis/bahkg/:year/:num', component:Treaty, name:'bahkg'},
    {path: '/:lang/legis/bacpg/:year/:num', component:Treaty, name:'bacpg'},
    {path: '/:lang/legis/hkts/:year/:num', component:Treaty, name:'hkts'},
    {path: '/:lang/legis/:abbr/:cap', component:SectionToc, name:'sectiontoc'},
    {path: '/:lang/legis/:abbr/:cap/full', component:SectionToc, name:'cap'},
    {path: '/:lang/legis/:abbr/:cap/:num', component:Section, name:'section'},
    {path: '/:lang/other/:abbr/', component:HOPTDb, name:'other-db'},
    {path: '/:lang/other/pd/:num', component:PD, name:'pd'},
    {path: '/:lang/other/:abbr/:year/:num', component:Pdf, name:'pdf'},
    {path: '/:lang/appealhistory/:type/:year/:num', component:AppealHistory, name:'appeal-history'},
    
    //redirect classic links
    ////Cases
    { path: '/:lang/hk/cases/:abbr',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/cases/:abbr/', name:'case-db', params: {lang: lang, abbr:to.params.abbr} }
      }
    },
    { path: '/:lang/hk/cases/:abbr/:year/:num.:extension',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/cases/:abbr/:year/:num', name:'case', params: {lang: lang, abbr:to.params.abbr, year:to.params.year, num:to.params.num} }
      }
    },
    { path: '/cgi-bin/sinodisp/:lang/hk/cases/:abbr/:year/:num.:extension',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/cases/:abbr/:year/:num', name:'case', params: {lang: lang, abbr:to.params.abbr, year:to.params.year, num:to.params.num} }
      }
    },
    { path: '/:lang/hk/cases/ukpc',
      redirect: to=>{
        return {path:'/:lang/cases/ukpc', name:'ukpc-db', params: {lang: 'en'} }
      }
    },
    { path: '/:lang/hk/cases/ukpc/:year/:num.:extension',
      redirect: to=>{
        return {path:'/:lang/cases/ukpc/:year/:num', name:'ukpc-pdf', params: {lang: 'en', year:to.params.year, num:to.params.num} }
      }
    },

    ////legis
    { path: '/:lang/hk/legis/:abbr',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/', name:'legis-db', params: {lang: lang, abbr:to.params.abbr} }
      }
    },
    { path: '/:lang/hk/legis/:abbr/toc-*.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/', name:'legis-db', params: {lang: lang, abbr: to.params.abbr} }
      }
    },
    { path: '/:lang/hk/legis/:abbr/:cap',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap', name:'sectiontoc', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap} }
      }
    },
    { path: '/:lang/hk/legis/:abbr/:cap/all.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/full', name:'cap', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap} }
      }
    },
    { path: '/:lang/hk/legis/:abbr/:cap/cur.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/full', name:'cap', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap} }
      }
    },
    { path: '/:lang/hk/legis/:abbr/:cap/:num-:date.:extension',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/:num', name:'section', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap, num: to.params.num} }
      }
    },
    { path: '/:lang/hk/legis/:abbr/:cap/:num.:extension',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/:num', name:'section', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap, num: to.params.num} }
      }
    },
    { //google index: https://www.hklii.hk/chi/databases.html
      path: '/:lang/databases.html',
      redirect: to=>{
        return {path:'/databases', name:'databases' }
      }
    },
    {  //google index: https://www.hklii.hk/compareversiondifference.php?lang=chi&cap=140&item=sch3
      path: '/compareversiondifference.php?lang=:lang&cap=:cap&item=:num',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        var abbr = /[a-zA-Z]/.test(to.params.cap)? 'ord' :  /^A/.test(to.params.cap)? 'instrument' : 'reg'
        return {path:'/:lang/legis/:abbr/:cap/:num', name:'section', params: {lang: lang, abbr: abbr, cap: to.params.cap, num: to.params.num} }
      }
    },
    { //google index: https://www.hklii.hk/chi//hk/legis/reg/537N
      path: '/:lang//hk/legis/:abbr/:cap',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap', name:'sectiontoc', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap} }
      }
    },
    { //google index: https://www.hklii.hk/chi//hk/legis/reg/toc-stroke-20.html
      path: '/:lang//hk/legis/:abbr/toc-*.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/', name:'legis-db', params: {lang: lang, abbr: to.params.abbr} }
      }
    },
   
    { //google index: https://www.hklii.hk/chi//hk/legis/ord/280/all.html
      path: '/:lang//hk/legis/:abbr/:cap/all.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/full', name:'cap', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap} }
      }
    },
    { //google index: https://www.hklii.hk/chi//hk/legis/ord/229/cur.html
      path: '/:lang//hk/legis/:abbr/:cap/cur.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/full', name:'cap', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap} }
      }
    },
    { //google index: https://www.hklii.hk/chi//hk/legis/ord/11/s9-19970630.html
      path: '/:lang//hk/legis/:abbr/:cap/:num-:date.:extension',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/:num', name:'section', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap, num: to.params.num} }
      }
    },
    { //google index: https://www.hklii.hk/chi//hk/legis/reg/50A/s35A.html, https://www.hklii.hk/chi//hk/legis/ord/132/sch4-20170623.html
      path: '/:lang//hk/legis/:abbr/:cap/:num.:extension',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/legis/:abbr/:cap/:num', name:'section', params: {lang: lang, abbr: to.params.abbr, cap: to.params.cap, num: to.params.num} }
      }
    },

    ////PD
    { path: '/:lang/hk/other/pd/:num.html',
      redirect: to=>{
        var lang = to.params.lang =='chi' ? 'tc': 'en'
        return {path:'/:lang/other/pd/:num', name:'pd', params:{lang: lang, num: to.params.num}}
      }
    },
   
    {path :'*', redirect: {name: '404'}, component: NotFound}

  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return new Promise(resolve => {
        router.app.$nextTick(() => {
          resolve({
            selector: decodeURI(to.hash),
            offset: {x: 0, y: scrollhelper.HEADEROFFSET},
          })
        })
      })
    } else {
      return {x: 0, y: 0}
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}